<template>
  <v-row>
    <v-col
      v-for="data in statisticsData"
      :key="data.title"
      cols="6"
      md="3"
    >
      <v-card
        class="mx-auto"
        max-width="344"
        outlined
      >
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-overline mb-4">
              {{ data.title }}
            </div>
            <v-list-item-title class="text-h5 mb-1">
              {{ data.total || '/' }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-avatar
            tile
            size="25"
          >
            <v-icon color="white">
              {{ data.icon }}
            </v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <AudienceAge :data="audienceGenderAgeData" />
        </v-col>
        <v-col
          cols="12"
          md="12"
        >
          <AudienceCityPodium :data="audienceCityPodiumData" />
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <AverageAgeByGender :data="audienceGenderAgeData" />
        </v-col>
        <v-col
          cols="12"
          md="12"
        >
          <AudienceLocalLanguage :data="audienceLocaleData" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

import {
  mdiAccountOutline,
  mdiCurrencyUsd,
  mdiTrendingUp,
  mdiDotsVertical,
  mdiLabelOutline,
  mdiBriefcaseVariantOutline,
  mdiInstagram,
  mdiGenderFemale,
  mdiGenderMale,
  mdiCake,
} from '@mdi/js';

import { i18n } from '@/plugins/i18n';
import { insightsFacebook } from '@secret-society/entities';
import { computed } from '@vue/composition-api';
import AudienceAge from './Overview/Blocks/AudienceAge.vue';
import AverageAgeByGender from './Overview/Blocks/AverageAgeByGender.vue';
import AudienceLocalLanguage from './Overview/Blocks/AudienceLocalLanguage.vue';
import AudienceCityPodium from './Overview/Blocks/AudienceCityPodium.vue';

export default {
  components: {
    AudienceAge, AverageAgeByGender, AudienceLocalLanguage, AudienceCityPodium,
  },
  props: {
    invitationData: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const { guest, facebookInsights } = props.invitationData;

    const guestGenderIsFemale = guest.gender === 'female';
    const statisticsData = [
      {
        title: i18n.t('guestTerms.followers'),
        total: '245k',
        icon: mdiInstagram,
      },
      {
        title: i18n.t('guestTerms.age'),
        total: i18n.t('guestTerms.ageValue', [guest.getAge()]),
        icon: mdiCake,
      },
      {
        title: i18n.t('guestTerms.gender'),
        total: guest.gender,
        icon: guestGenderIsFemale ? mdiGenderFemale : mdiGenderMale,
      },
      {
        title: i18n.t('guestTerms.profession'),
        total: guest.profession,
        icon: mdiBriefcaseVariantOutline,
      },
    ];
    const audienceCityPodiumData = computed(() => facebookInsights.getLifetimeInsights(insightsFacebook.LifetimeName.audienceCity));
    const audienceLocaleData = computed(() => facebookInsights.getLifetimeInsights(insightsFacebook.LifetimeName.audienceLocale));
    const audienceGenderAgeData = computed(() => facebookInsights.getLifetimeInsights(insightsFacebook.LifetimeName.audienceGenderAge));

    return {
      statisticsData,

      // computed
      audienceCityPodiumData,
      audienceLocaleData,
      audienceGenderAgeData,

      // icons
      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiAccountOutline,
        mdiLabelOutline,
        mdiCurrencyUsd,
      },
    };
  },
};
</script>
